module.exports = __webpack_public_path__ + "ic-insights-application-white.svg?896d16cf867d87efff72089f4da6b9f0";